import { Stack } from "@mui/material";
import { Outlet, useLocation, useNavigate, useOutletContext } from "react-router-dom";
import CohortDemographics from "./CohortDemographics";
import Tab from "../../../app/Tab";
import ResearchDomains from "./ResearchDomains";
import { SyntheticEvent, useEffect, useState } from "react";
import { LassoTab, LassoTabs } from "../../../components/LassoTabs";
import ByVisits from "./ByVisits";

const DashboardTabs: Tab<any>[] = [
    new Tab("", CohortDemographics, true, "By Cohort Demographics"),
    new Tab("by-domain", ResearchDomains, false, "By Research Domain/By Variable"),
    new Tab("by-visit", ByVisits, false, "By Visits")
];

const ExploreLayout = () => {
    const context = useOutletContext();
    const [ currentTab, setCurrentTab ] = useState(DashboardTabs[0].path);
    const navigate = useNavigate();
    const location = useLocation();
    const { setHeaderText, setPreviousLocation } = useOutletContext<any>();

    useEffect(() => {
        setHeaderText("Explore and Search Data");
        setCurrentTab(location.pathname.replace('/', ''));
        setPreviousLocation();
    }, []);

    const handleTabChange = (event: SyntheticEvent<Element, Event>, value: any) => {
        setCurrentTab(value);
        navigate(`/${value}${value !== '' ? location.search : ''}`);
    };

    return (
        <Stack height={"calc(100% - 62px)"} paddingBottom={2} gap={3}>
            <LassoTabs value={currentTab} onChange={handleTabChange}>
                {DashboardTabs.map((tab: Tab<any>) => (
                    <LassoTab key={tab.label} label={tab.label} value={tab.path} />
                ))}
            </LassoTabs>
            <Outlet context={context}/>
        </Stack>
    )
}

export { DashboardTabs };

export default ExploreLayout;